<template>
  <a @click.prevent="openMobileLockerUrl">
    <div class="bg-accent row justify-center g-accent q-px-xs-md q-py-xs-sm">
      <div class="q-my-xs text-center">
        <span
          class="q-px-xs self-center text-overline text-primary"
          style="line-height: 24px"
          >powered by</span
        >
        <q-img
          :src="poweredByAsset"
          fit="scale-down"
          position="0,0"
          height="24px"
          width="80px"
        />
      </div>
    </div>
  </a>
</template>

<script setup lang="ts">
import { openExternalUrl } from 'src/services/utilities'
import { useApplicationThemeStore } from 'stores/application-theme'

const applicationThemeStore = useApplicationThemeStore()
const poweredByAsset = applicationThemeStore.ApplicationTheme
  ?.powered_by_asset as string

function openMobileLockerUrl() {
  openExternalUrl('https://www.mobilelocker.eu', true)
}
</script>
